module.exports = __webpack_public_path__ + "static/media/enable_touchpad_tap_clicking.0980683e.md";